@if (loading) {
    <div class="loading-item-overlay">
        <div class="fancy-loader submodule"></div>
    </div>
} @else {
    @if (row) {
        <ng-container>
            <div class="detail-page-action-bar">
                <button class="btn btn-cerrix" (click)="save()">
                    <i class="fas fa-save"></i>
                    <span class="d-none d-lg-inline">{{
                        "editor.saveButton" | t
                    }}</span>
                </button>

                @if (row.ID && !config.disableDelete) {
                    <div class="right-area">
                        <button class="btn btn-danger" (click)="delete()">
                            <i class="fal fa-trash"></i>
                            <span class="d-none d-lg-inline">{{
                                "editor.deleteButton" | t
                            }}</span>
                        </button>
                    </div>
                }
            </div>

            @for (category of config.categories; track category) {
                <ng-container
                    *ngTemplateOutlet="categoryRenderer; context: { category: category }"
                ></ng-container>
            }
        </ng-container>
    } @else {
        <div class="select-item-overlay">
            <span>{{ "editor.noItemSelected" | t }}</span>
        </div>
    }
}

<ng-template #categoryRenderer let-category="category">
    @if (category.showInline) {
        <ng-container
            *ngTemplateOutlet="fieldRowRenderer; context: { fields: category.fields }"
        ></ng-container>
    } @else {
        <div class="detail-page-card">
            <div class="detail-page-card-title">{{ category.categoryName }}</div>
            @if (category.buttons) {
                <div class="detail-page-card-actions">
                    @for (button of category.buttons; track button) {
                        <button
                            (click)="executeCategoryButton(button)"
                            class="{{ button.class ? button.class : 'btn btn-raised' }}"
                        >
                            @if (button.icon) {
                                <i [class]="button.icon" aria-hidden="true"></i>
                            }
                            <span [ngClass]="{ 'd-none d-xl-inline ms-2': button.icon }">{{
                                button.name
                            }}</span>
                        </button>
                    }
                </div>
            }
            <div class="detail-page-card-body padded cerrix-control-sm">
                <ng-container
                    *ngTemplateOutlet="fieldRowRenderer; context: { fields: category.fields }"
                ></ng-container>
            </div>
        </div>
    }
</ng-template>

<ng-template #fieldRowRenderer let-fields="fields">
    <div class="row">
        @for (field of fields; track field) {
            <ng-container
                *ngTemplateOutlet="fieldRenderer; context: { field: field }"
            ></ng-container>
        }
    </div>
</ng-template>

<ng-template #fieldRenderer let-field="field">
    @if (!field.hideInEdit) {
        <div
            class="generic-field-editor form-group col-{{
                field.editorWidth ? field.editorWidth : '12'
            }}"
        >
            @if (field.fieldType >= 0) {
                <generic-field-editor
                    [row]="row"
                    [field]="field"
                    [editEnabled]="!field.isReadonly"
                    [additionalData]="additionalData"
                    [customEditor]="config.customEditor"
                    [standingDataType]="type"
                    (valueChanged)="genericFieldValueChanged($event)"
                ></generic-field-editor>
            } @else {
                <ng-container
                    *ngTemplateOutlet="categoryRenderer; context: { category: field }"
                ></ng-container>
            }
        </div>
    }
</ng-template>
